import { Link, useNavigate } from "react-router-dom";
import { BackArrowIcon } from "../../Assets/icons/BackArrowIcon";
import logo from "../../Assets/images/logo.png";
import { useState } from "react";
import { authService } from "../../services/authServices";
import { toast } from "react-toastify";

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      newErrors.email = "Invalid email format";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setEmail(value);
    // Clear error when user starts typing
    if (errors.email && value.trim() !== '') {
      setErrors((prev) => ({ ...prev, email: "" }));
    } else if (value.trim() === '') {
      validateForm();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await authService.forgotPassword(email);
      if (response.status === "ok" || response.code === 200) {
        navigate(`/otp-verification?email=${email}&type=forgot-password`);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message?.[0]?.detail;
      toast.error(errorMessage);
    }
  }

  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center">
            <Link href="" className="authlogo">
              <img src={logo} width={337} height={90} alt="logo" />
            </Link>
          </div>
          <div className="authcardmain">
            <div className="authcardheader">
              <span className="h_2 white-font fw-medium mb-3 d-inline-block">
                Forgot your password?
              </span>
              <p className="white-font fw-normal font-14 authcardsubtitle">
                Enter your registered email to reset your password. We will send
                OTP to your registered email address
              </p>
            </div>
            <form className="authform" onSubmit={handleSubmit}>
              <div className="form-group mb-3 pb-1">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={handleInputChange}
                />
                {errors.email && (
                  <span className="required-text">{errors.email}</span>
                )}
              </div>
              <button type="submit" className="btn-primary-custom w-100">
                Next
              </button>
              <div className="d-flex align-items-center mt-4 justify-content-center">
                <Link to="/login" className="font-12 fw-normal primary-font">
                  <BackArrowIcon className="me-2" />
                  Back to Sign In
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
